import { Component} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { openCloseAnimation } from 'src/assets/animations/openCloseAnImation';
import { removeTransition } from 'src/assets/animations/removeAnimation';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-header-superior',
    templateUrl: './header-superior.component.html',
    animations: [removeTransition, openCloseAnimation]
})
export class HeaderSuperiorComponent {

    public showLanguages = false;
    public selectedLanguage;
    public webUrl = environment.webUrl;

    constructor(private readonly _translateService: TranslateService) {}

    ngOnInit(): void {
        if (window.navigator.language.includes('es')) {
            this.selectedLanguage = 'header-superior.idiomas.esp'
        } else {
            this.selectedLanguage = 'header-superior.idiomas.ingUSA'
        }
    }

    public changeLanguage(language) {
        if (language === 1) {
            this._translateService.use('es-ES');
            this._translateService.setDefaultLang('es-ES');
            this.selectedLanguage = 'header-superior.idiomas.esp';
            this.showLanguages = false;
        } else if (language === 2) {
            this._translateService.use('en-US');
            this._translateService.setDefaultLang('en-US');
            this.selectedLanguage = 'header-superior.idiomas.ingUK';
            this.showLanguages = false;
        } else if (language === 3) {
            this._translateService.use('en-US');
            this._translateService.setDefaultLang('en-US');
            this.selectedLanguage = 'header-superior.idiomas.ingUSA';
            this.showLanguages = false;
        }
    }
}
